import { differenceInDays, isValid } from 'date-fns';

/**
 * Gets the number of days since an asset was created.
 * Uses date-fns for consistent date handling across the codebase.
 *
 * @param displayDate - The ISO date string from the asset's displayDate field
 *                      (resolves to upload_completed_at || inserted_at).
 *                      For version stacks, use getUploadDisplayDate() to get this value.
 * @returns The number of days since creation. Returns -1 if date is invalid, missing, or in the future.
 */
export function getDaysSinceCreated(
  displayDate: string | null | undefined
): number {
  if (!displayDate) return -1;

  const createdDate = new Date(displayDate);

  if (!isValid(createdDate)) return -1;

  const daysDifference = differenceInDays(new Date(), createdDate);

  // If date is in the future, treat as invalid data
  if (daysDifference < 0) return -1;

  return daysDifference;
}
